export enum INVITATION_REQUEST_ID_LIST {
  GET_TNC_STATUS = 'GET_TNC_STATUS',
  GET_TNC_DETAIL = 'GET_TNC_DETAIL',
  POST_INVITATION_REGISTRATION = 'POST_INVITATION_REGISTRATION'
}
